export default "__VITE_ASSET__BqgabFOq__"